import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest, MutationReason } from './_common.js';
export const LeaderboardBracket = z.object({
    bracket_id: z.string(),
    game_id: z.string(),
    week_starts_at: IsoDateTime,
    bracket_idx: z.number().int(),
    user_count: z.number().int(),
    status: z.enum(['active', 'resolved']),
});
export const LeaderboardEntry = z.object({
    bracket_id: z.string(),
    user_id: z.string(),
    username: z.string(),
    display_name: z.string(),
    avatar_url: z.string().nullable(),
    score: z.number().int(),
    rank: z.number().int(),
    disqualified: z.boolean(),
    prize_awarded: z.number().int().nullable(),
});
export const AdminLeaderboardListBracketsRequest = PageRequest.extend({
    game_id: z.string().optional(),
    week_starts_at: IsoDateTime.optional(),
    status: z.enum(['active', 'resolved']).optional(),
});
export const AdminLeaderboardListBracketsResponse = z.object({
    items: z.array(LeaderboardBracket),
    page: PageMeta,
});
export const AdminLeaderboardGetBracketRequest = z.object({
    bracket_id: z.string(),
});
export const AdminLeaderboardGetBracketResponse = z.object({
    bracket: LeaderboardBracket,
    entries: z.array(LeaderboardEntry),
});
export const AdminLeaderboardDisqualifyRequest = z.object({
    user_id: z.string(),
    reason: MutationReason,
});
export const AdminLeaderboardDisqualifyResponse = z.object({
    bracket_id: z.string(),
    user_id: z.string(),
    disqualified_at: IsoDateTime,
});
export const AdminLeaderboardManualPrizeRequest = z.object({
    user_id: z.string(),
    amount: z.number().int().min(1),
    cosmetic_id: z.string().nullable().default(null),
    reason: MutationReason,
});
export const AdminLeaderboardManualPrizeResponse = z.object({
    ledger_entry_id: z.number().int(),
    cosmetic_granted: z.boolean(),
});
export const AdminLeaderboardForceResetRequest = z.object({
    game_id: z.string(),
    reason: MutationReason,
});
export const AdminLeaderboardForceResetResponse = z.object({
    brackets_resolved: z.number().int(),
    brackets_created: z.number().int(),
    prizes_paid: z.number().int(),
});
//# sourceMappingURL=leaderboard.js.map